/**
 * Generates the html for a visible appointment on the calendar
 *
 * @param appointment
 * @param type
 * @returns {string}
 */
function get_course_appointment_html(appointment, type) {
    if (type === 'l') {
        let desc = appointment.description;
        if (this_user_has_roles(['Administrator', 'Scheduler']) && appointment.course_code != null && appointment.course_code != undefined && appointment.course_code != 'null' && appointment.course_code.length > 0) {
            desc = '<b>' + appointment.course_code + '</b>: ' + desc;
        }
        let d = appointment.start_datetime;
        const date_str = ['Zo', 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za'][d.getDay()] + ' ' + d.getDate() + ' ' + ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'][d.getMonth()] + ' ' + d.getFullYear();
        const start_time = (d.getHours() < 10 ? '0' + d.getHours() : d.getHours()) + ':' + (d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes());
        d = appointment.end_datetime;
        const end_time = (d.getHours() < 10 ? '0' + d.getHours() : d.getHours()) + ':' + (d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes());

        return '<tr class="appointment-wrapper" data-id="' + appointment.id + '" data-time="' + appointment.start_datetime.getTime() + '">' +
            '<td data-title="Datum"><span class="date-str">' + date_str + '</span></td>' +
            '<td class="ball-wrapper"><span class="color-ball"></span></td>' +
            '<td data-title="Tijd">' + start_time + ' - ' + end_time + '</td>' +
            '<td data-title="Cursus">' + desc + ' ' + appointment.student_count + '/' + appointment.max_count + '</td>' +
            '<td data-title="Locatie">' + appointment.address_name + '</td>' +
            '<td data-title="Docent(en)">' + appointment.teacher_names.join(', ') + '</td>' +
            '</tr>';
    } else {
        let desc = appointment.description;
        if (this_user_has_roles(['Administrator', 'Scheduler']) && appointment.course_code != null && appointment.course_code != undefined && appointment.course_code != 'null' && appointment.course_code.length > 0) {
            desc = appointment.course_code;
        }
        return '<div class="appointment-wrapper" data-id="' + appointment.id + '"><div class="appointment-container"><div class="appointment">' + desc + ' ' + appointment.student_count + '/' + appointment.max_count + '</div></div></div>';
    }
}

/**
 * Write html into the info-box that's shown on-hover in the calendar
 *
 * @param c
 * @param data
 */
function fill_course_info_box(c, data) {

    var teachers = [];
    data.teachers.forEach(function (teacher) {
        teachers.push(teacher.fancyName);
    });

    var keys = [ 'name', 'street', 'street_no', 'street_no_adding', 'postal_code', 'city'];
    var location = [];
    keys.forEach(function (key) {
        if (data.address[key] != null && (data.address[key].length > 0 || data.address[key] > 0)) {
            location.push(data.address[key]);
        }
    });

    c.html('<p><b>Cursus:</b> ' + data.course.description + '</p>');
    if (this_user_has_roles(['Administrator', 'Scheduler'])) {
        c.find('p').append('<br /><b>Nummer:</b> ' + data.appointment_group_id);
    }

    let start_time = data.start_datetime.split(' ')[1].split(':');
    start_time = start_time[0] + ':' + start_time[1];
    let end_time = data.end_datetime.split(' ')[1].split(':');
    end_time = end_time[0] + ':' + end_time[1];
    c.find('p').append('<br /><b>Tijden: </b>' + start_time + ' - ' + end_time);

    if (data.incompany_names.length > 0 && this_user_has_roles(['Administrator', 'Scheduler', 'Supervisor', 'Teacher'])) {
        c.find('p').append('<br /><b>In-company:</b> ' + data.incompany_names.join(', '));
    }
    c.find('p').append('<br /><b>Onderdeel:</b> ' + data.courseComponent.description +
        '<br /><b>Ingeschreven:</b> ' + data.student_count + '/' + data.max_count);
    if (data.teachers != undefined && this_user_has_roles(['Administrator', 'Scheduler'])) {
        c.find('p').append('<br /><b>Docent' + (data.teachers.length > 1 ? 'en' : '') + ':</b> ' + (teachers.length == 0 ? '-' : teachers.join(', ')));
    }
    if (data.course.online === 1) {
        const onlineCredentialsMap = {
            join_code: 'join_code',
            join_password: 'join_password',
            join_url: 'join_url',
        };

        c.find('p').append('<br /><b>Dit is een online cursus</b>');
        if (data.join_code !== null && data.join_code.length > 0) {
            c.find('p').append(`<br /><b>Code:</b> ${data.join_code}`);
        }
        if (data.join_password !== null && data.join_password.length > 0) {
            c.find('p').append(`<br /><b>Wachtwoord:</b> ${data.join_password}`);
        }
        // if (data.join_url.length > 0) {
        //     c.find('p').append(`<br /><b>Link:</b> <a href="${data.join_url}" target="_blank">${data.join_url}</a>`);
        // }
    } else {
        c.find('p').append('<br /><b>Locatie:</b> ' + location.join(', '));
        if (data.room_description != undefined && data.room_description.length > 0 && this_user_has_roles(['Administrator', 'Scheduler'])) {
            c.find('p').append('<br /><b>Lokaal:</b> ' + data.room_description);
        }
    }
    if (this_user_has_roles(['Administrator', 'Scheduler', 'Supervisor', 'Teacher'])) {
        c.find('p').append('<br /><b>Status:</b> ' + data.status_description + '</b>');
    }
}

/**
 * Remove a student from the appointment
 *
 * @param aid
 * @param cid
 * @param name
 * @returns {boolean}
 */
function cancel_enrollment(aid, cid, name) {
    var $ = jQuery.noConflict();


    name = decodeURI(name);


    confirm("Weet u zeker dat u \"" + name + "\" uit de planning wilt verwijderen?", function () {
        var delete_enrollment = function (all) {
            $.post("/calendar/cancelEnrollment/" + aid, {id: cid, all: all}, function (data) {
                squde_reload_for_flashes();
                // if($('#scheduled_courses').find('table').length > 0) {
                //     $('#scheduled_courses').find('table').reloadThisElement();
                // }
                // $('select#students_selector').trigger('change');
                reload_location_if_needed(false);
            });
        };

        $('body').isLoading('dark');
        $.getJSON("/calendar/ajaxGetAppointment/" + aid + '/courses', function (app) {
            $('body').doneLoading();
            if (app.siblings.length == 1) {
                delete_enrollment(true);
            } else {
                confirm("Wilt u de cursist voor alle onderdelen uitschrijven?", function () {
                    delete_enrollment(true);
                }, function () {
                    delete_enrollment(false);
                })
            }
        });

    });
    return false;
}

/**
 * Generate a presence list for this appointment
 *
 * @param id
 * @returns {boolean}
 */
function generate_presence_list(id) {
    var url = '/calendar/generatePresenceList/' + id;
    if (window.pressed('alt')) {
        window['pressed_keys'] = [];
        url = url + '?stream=true';
        window.open(url);
    } else {
        window.location.assign(url);
    }
    return false;
}

/**
 * Generate a competency list for this appointment
 *
 * @param id
 * @returns {boolean}
 */
function generate_competency_list(id) {
    var url = '/calendar/generateCompetencyList/' + id;
    if (window.pressed('alt')) {
        window['pressed_keys'] = [];
        url = url + '?stream=true';
        window.open(url);
    } else {
        window.location.assign(url);
    }
    return false;
}

/**
 * Open the presence list view popup
 *
 * @param appointment_id
 * @returns {boolean}
 */
function get_presence_list_view_popup(appointment_id) {
    const $ = jQuery.noConflict();
    $.squdeAjaxPopup({
        url: '/calendar/getPresenceViewer/' + appointment_id,
        onOpen: function (elm, popup) {
            elm.find('.present-students-table').reloadThisElement();
            elm.find('[data-present-passed-logic-wrapper]').each(function() {
                initPresencePassLogic($(this)[0]);
            });
            var form = elm.find('form');
            form.find('[type=submit]').click(function (e) {
                e.preventDefault();
                var button = $(this);
                var not_all_days = [];
                form.find('input[name^="also_passed_students"]').remove();
                form.find('input[name^="present_students"]:not(:checked)').each(function () {
                    not_all_days[not_all_days.length] = [$(this).val(), $(this).parents('td').next().find('a').html()];
                });

                form.submit();
            });
            form.ajaxFormSubmit(function (data) {
                squde_reload_for_flashes();
                reload_location_if_needed(document.closeWindow);
            });
        }
    });
    return false;
}

/**
 * This function gets called when the edit-appointment screen is opened
 *
 * @param appointmentId
 * @param elm
 * @param popup
 * @param callback
 */
async function edit_course_appointment(appointmentId, elm, popup, callback) {
    const $ = jQuery.noConflict();
    elm.find('[data-course-selector]').courseSelector();
    elm.find('[data-nibhv_location-selector]').nibhvLocationSelector();
    elm.find('a.add-person').click(function () {
        add_contact({
            callback: function (contactObj, popupElm, popupObj) {
                popupObj.close();
                elm.squdeReloadAjaxPopup();
            }
        });
    });

    elm.find('form').ajaxFormSubmit(function (data) {
        if (callback === undefined) {
            squde_reload_for_flashes(function () {
                reload_location_if_needed(document.closeWindow);
            });
        } else {
            $('body').doneLoading();
            callback(data);
        }
    }.bind([elm, popup]), function (xhr, status, error) {
        $('body').doneLoading();
        if ($('.squde-flash').length === 0) {

            var arr = JSON.parse(xhr.responseText);
            var date_problem = false;
            for (var key in arr) {
                var p = key.split('.');
                if (p[0] == 'appointments' && (p[2] == 'start_datetime' || p[2] == 'end_datetime')) {
                    var tr = elm.find('.course-components-appointments-wrapper').find('table').find('tbody').find('tr:eq(' + p[1] + ')');
                    tr.find('a').addClass('is-invalid-label');
                    tr.find('input').bind('change.removeInvalidLabel', function () {
                        var tr = $(this).parents('tr');
                        tr.find('.is-invalid-label').removeClass('is-invalid-label');
                        tr.find('input').unbind('change.removeInvalidLabel');
                    });
                    date_problem = true;
                }
            }
            var str = "Er ging iets mis bij het opslaan";
            if (date_problem === true) {
                str = "Begindatum moet voor de einddatum zijn.";
            }
            squde_flash(str, "alert");
        }
    }.bind([elm, popup]), function () {
        $('body').isLoading('dark');
    });

    elm.isLoading();

    const [course, contacts, appointment] = await Promise.all([
        $.get(`/ajax/getCourse/${elm.find('[data-course-selector]').attr('data-current-value')}`),
        $.get('/ajax/specialSelectorSearch', {
            type: 'contact',
            limit: 1000,
            returnObjects: true,
            with: [
                'roles',
                'skills'
            ],
            filters: {
                roles: [
                    'teacher',
                    'lotus',
                ]
            }
        }),
        $.getJSON(`/ajax/getAppointment/${appointmentId}`)
    ]);

    await initiateComponentLogic(elm, {
        course,
        contacts,
        appointment
    });
    init_edit_responsible_times(elm);

    elm.doneLoading();
}

/**
 * Toggle incompany course on / off
 *
 * @param sender
 */
function toggle_incompany(sender) {
    var elm = jQuery(sender);
    var screen = elm.parents('.scroll-screen');
    if (screen.length == 0) {
        screen = elm.parents('.sub-screen-wrapper');
    }
    var name = elm.attr('name');
    if (screen.find('input[name=' + name + ']:checked').val() == 1) {
        screen.find('.incompany-form').show();
        screen.find('.not-incompany-form').hide();
    } else {
        screen.find('.incompany-form').hide();
        screen.find('.not-incompany-form').show();
    }
}

function toggle_appointment_invoice_relation(sender) {
    const elm = jQuery(sender);
    const name = elm.attr('name');

    let screen = elm.parents('.scroll-screen');
    if (screen.length === 0) screen = elm.parents('.sub-screen-wrapper');

    const select = screen.find('select[name="invoice_relation_id"]');
    const originalValue = parseInt(select.attr('data-value'));

    const show = parseInt(screen.find(`input[name=${name}]:checked`).val()) === 1;
    screen.find('.invoice-relation-form').toggle(show);


    if (!show) select.empty();

    const table = screen.find('table[data-reloadable-url]');

    const afterTableChanged = () => {
        // Also trigger this same method when
        table
            .find('input[type=checkbox]:not(.check-whole-table)')
            .unbind('change.invoice-relations')
            .bind('change.invoice-relations', function() {
                select.empty();
                let companies = table.getThisElementsData()
                if (!companies || companies.length === 0) {
                    screen.find(`input[name=${name}]`).attr('disabled', 'disabled');
                    return;
                }
                companies = companies.filter((company) => {
                    return table.find(`tr[data-id="${company.id}"] input[type="checkbox"]:checked`).length > 0;
                });
                if (companies.length === 0) {
                    screen.find(`input[name=${name}]`).attr('disabled', 'disabled');
                    return;
                }
                const invoiceRelations = _
                    .uniq(companies
                        .filter((company) => company.invoice_relation_id !== null)
                        .map((company) => company.invoice_relation)
                    )
                ;

                const totalInvoiceCompanies = companies
                    .filter((company) => company.invoice_relation_id === null)
                    .filter((company) => !invoiceRelations.map((rel) => rel.id).includes(company.id))
                    .concat(invoiceRelations);

                screen.find(`input[name=${name}]:not(.invoiced)`).removeAttr('disabled');
                _
                    .sortBy(totalInvoiceCompanies, (company) => {
                        return company.name.toLowerCase();
                    })
                    .forEach((company) => {
                        select.append(`<option value="${company.id}">${company.name}</option>`);
                    });
                if (!originalValue || !totalInvoiceCompanies.map((c) => c.id).includes(originalValue)) {
                    let firstId = companies[0].invoice_relation_id ? companies[0].invoice_relation_id : companies[0].id;
                    select.val(firstId);
                } else {
                    select.val(originalValue);
                }
                select.trigger('change');
            });
        table.find('input[type=checkbox]:not(.check-whole-table):first').trigger('change.invoice-relations');
    }

    table
        .unbind('onReload.invoice-relations')
        .bind('onReload.invoice-relations', afterTableChanged);

    afterTableChanged();
}

/**
 * Opens the screen in order to generate invoices from this course
 *
 * @param id
 * @returns {boolean}
 */
function generate_invoices_from_appointment(id) {
    var $ = jQuery.noConflict();
    $.squdeAjaxPopup({
        url: '/calendar/makeInvoices/' + id,
        onOpen: function (elm, popup) {
            elm.find('form').ajaxFormSubmit(function (data, form) {
                $('body').doneLoading();
                ajax_popup_scroll_to_next_screen(function () {
                    elm.find('.visual-icon-invoice').addClass('fly-in');
                    elm.find('.close-and-reload').click(function() {
                        reload_location_if_needed(true);
                        return false;
                    })
                });
            }.bind([elm, popup]), function (xhr, status, error) {
                $('body').doneLoading();
            }.bind([elm, popup]), function () {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}

function generate_invoice_from_appointment(id) {
    var $ = jQuery.noConflict();
    $.post({
        url: '/calendar/generateInvoices/' + id,
        success: (data) => {
            squde_reload_for_flashes();
            if (data.length > 0) {
                reload_location_if_needed(false);
                const invoice = data[0];
                ask(`Factuur gemaakt voor ${invoice.contact_company_name}.<br />Wat wilt u nu doen?`,[
                    {
                        title: 'Factuur bekijken',
                        callback: function() {
                            redirect_and_do('/administration/invoices', function() {
                                view_invoice(invoice.id);
                            });
                        }
                    },
                    {
                        title: 'Hier blijven',
                        buttonClass: 'secondary',
                        callback: function() {
                            reload_location_if_needed(true);
                        }
                    }
                ]);
            }
        }
    });
    return false;
}

/**
 * Gets called when the rooms-select-element gets changed
 *
 * @param sender
 */
function change_rooms(sender) {
    var $ = jQuery.noConflict();
    var e = $(sender).val();
    if (e > 0 && $('select#room_id').length > 0) {
        $('select#room_id').find('option[data-establishment]:not([data-establishment="' + e + '"])').hide();
        $('select#room_id').find('option[data-establishment="' + e + '"]').show();
    } else {
        $('select#room_id').find('option').show();
    }
}

/**
 * Shows location info on the map
 *
 * @param elm
 */
function show_location(elm) {
    var $ = jQuery.noConflict();
    var sel = $(elm);
    var opt = sel.find('option[value=' + sel.val() + '][data-establishment]');

    var w = $('.location-wrapper');
    w.isLoading();
    var frame = w.find('iframe');

    var src = frame.attr('src');
    frame.attr('src', 'about:blank');

    var p = src.split('&q=');

    if (opt.length > 0) {
        var data = JSON.parse(opt.attr('data-establishment'));
        /*
        {"id":1,"name":"Hoofdkantoors","postal_code":"7715 PP","city":"Punthorst","street":"Meester J.B. Kanlaan","street_no":31,"street_no_adding":"","country_code":"NL","created_at":"2017-11-02 11:15:38","updated_at":"2017-11-02 11:34:00","location":"Meester J.B. Kanlaan 31, 7715 PP, Punthorst"}
         */

        var str = data.street + '+' + data.street_no;
        if (data.street_no_adding != undefined && data.street_no_adding != null && data.street_no_adding.length > 0) {
            str = str + '+' + data.street_no_adding;
        }
        str = str + ',' + data.postal_code + ',' + data.city;

        p[1] = str;

        // Hondsdraf+144,+8255+KB+Swifterbant

        // alert(JSON.stringify(data));
    } else {
        p[1] = 'Nederland';
    }
    frame.attr('src', p.join('&q='));

    frame.load(function () {
        w.doneLoading();
    });
}

/**
 * Shows the screen with form to create new reservation
 *
 * @param appointment_id
 * @returns {boolean}
 */
function make_reservation(appointment_id) {
    var $ = jQuery.noConflict();

    $.squdeAjaxPopup({
        url: '/calendar/getReservationView/' + appointment_id,
        size: 'medium',
        onOpen: function (elm, popup) {
            elm.find('select#company_id').companySelector();
            elm.find('select#contact_id').contactSelector();
            elm.find('form').ajaxFormSubmit(function (data, form) {
                $('body').doneLoading();
                squde_reload_for_flashes();
                reload_location_if_needed();
            }.bind([elm, popup]), function (xhr, status, error) {
                $('body').doneLoading();
            }.bind([elm, popup]), function () {
                $('body').isLoading('dark');
            });
        }
    });

    return false;
}

/**
 * Shows the reservations screen
 *
 * @param appointment_id
 * @returns {boolean}
 */
function view_all_reservations(appointment_id) {
    var $ = jQuery.noConflict();

    $.squdeAjaxPopup({
        url: '/calendar/getAllReservationsView/' + appointment_id,
        onOpen: function (elm, popup) {
        }
    });

    return false;
}

/**
 * View your existing reservation
 *
 * @param id
 * @returns {boolean}
 */
function view_reservation(id) {

    var $ = jQuery.noConflict();

    $.squdeAjaxPopup({
        url: '/calendar/getReservation/' + id,
        size: 'medium',
        onOpen: function (elm, popup) {
            elm.find('form').ajaxFormSubmit(function (data, form) {
                $('body').doneLoading();
                squde_reload_for_flashes();
                reload_location_if_needed(document.closeWindow);
            }.bind([elm, popup]), function (xhr, status, error) {
                $('body').doneLoading();
            }.bind([elm, popup]), function () {
                $('body').isLoading('dark');
            });
        }
    });

    return false;
}

/**
 * Remove this reservation
 *
 * @param id
 * @param company_name
 * @returns {boolean}
 */
function delete_reservation(id, company_name) {
    var $ = jQuery.noConflict();
    company_name = decodeURI(company_name);

    confirm("Weet u zeker dat u de reservering voor \"" + company_name + "\" wilt verwijderen?", function () {
        $('body').isLoading('dark');
        $.ajax({
            url: "/calendar/deleteReservation",
            data: {id: id},
            type: "POST",
            success: function (data) {
                $('[data-object-type=\'reservation\'][data-id=\'' + id + '\'').remove();
                $('body').doneLoading();
                reload_location_if_needed(false);
            },
            error: function (e) {
                $('body').doneLoading();
                squde_flash("Er ging helaas iets mis.", "alert");
            }
        });
    });

    return false;
}

function init_edit_responsible_times(elm) {
    const $ = jQuery.noConflict();
    elm.find('a.change-times-button:not(.edit-time-event-init)').each(function() {
        const button = $(this);
        button.addClass('edit-time-event-init');
        const wrapper = button.parents('.teacher-wrapper:first');

        const checkbox = wrapper.find('input[type="checkbox"]');

        checkbox
            .unbind('change.edit-times')
            .bind('change.edit-times', function() {
                const checked = $(this).is(':checked');
                button.toggle(checked);
            })
            .trigger('change.edit-times');


        const customTimeWrapper = wrapper.find('span.custom-time');

        const fromInput = wrapper.find('.time-from');
        const toInput = wrapper.find('.time-to');
        const originalFrom = fromInput.attr('data-original-value');
        const originalTo = toInput.attr('data-original-value');

        const toggleTimeIndicators = (from, to) => {
            const changed = from !== originalFrom || to !== originalTo;

            customTimeWrapper.toggle(changed === true);
            customTimeWrapper.find('.custom-time-from').html(from);
            customTimeWrapper.find('.custom-time-to').html(to);

            button.find('.edit-time').toggle(changed === false);
        }

        toggleTimeIndicators(fromInput.val(), toInput.val());

        button.unbind('click').click(function () {

            const from = fromInput.val();
            const to = toInput.val();



            const html = `
<form action="#">
    <div class="row">
        <div class="column small-12 medium-6">
            <label for="start_time">Van: <a href="#" data-open-timepicker>` + from + `</a><input type="text" name="from" value="` + from + `" data-timepicker /></label>
        </div>
        <div class="column small-12 medium-6">
            <label for="end_time">Tot: <a href="#" data-open-timepicker>` + to + `</a><input type="text" name="to" value="` + to + `" data-timepicker /></label>
        </div>
    </div>
    <div class="row">
        <div class="column text-center"><br />
            <button class="button secondary">Sluiten</button> <input type="submit" class="button primary" class="close-form" value="Opslaan" /> 
        </div>
    </div>
</form>`;

            foundationPopup('<h4>Tijden wijzigen</h4>' + html, function (elm, popup) {
                elm.find('br:first').remove();
                elm.find('button.close-form').click(function (e) {
                    e.preventDefault();
                    popup.close();
                });
                elm.find('form').submit(function() {
                    const data = $(this).serializeJSON();

                    toggleTimeIndicators(data['from'], data['to']);

                    fromInput.val(data['from']);
                    toInput.val(data['to']);

                    popup.close();
                    return false;
                });
                reload_timepickers();
            }, "tiny");

            return false;
        });
    })
}
function sign_for_presence(appointmentId, contactId) {
    const $ = jQuery.noConflict();

    $.squdeAjaxPopup({
        url: `/calendar/signatureInterface/${appointmentId}/${contactId}`,
        size: 'full',
        onOpen: function (elm, popup) {
            elm.find('form').ajaxFormSubmit(function (data, form) {
                $('body').doneLoading();
                squde_reload_for_flashes();
                reload_location_if_needed(false);
                popup.close();
            }.bind([elm, popup]), function (xhr, status, error) {
                $('body').doneLoading();
            }.bind([elm, popup]), function () {
                $('body').isLoading('dark');
            });
        }
    });

    return false;
}
